module.exports = __webpack_public_path__ + "../resources/img/saved_icon.6801ddcd.svg";